module.exports = __webpack_public_path__ + "static/media/flower-specs.20ac7913.png";